import _debounce from 'lodash.debounce';

export const DEFAULT_WAIT = 250;

export function debounceDecorator(wait, target, name, descriptor) {
	descriptor.value = _debounce(descriptor.value, wait);
	return descriptor;
}

export default function debounce(...args) {
	if (args.length === 1) {
		return debounceDecorator.bind(null, args[0]);
	}

	return debounceDecorator(DEFAULT_WAIT, ...args);
}



// WEBPACK FOOTER //
// ./src/utils/debounce.js